import { AbstractGlobalProvider } from './provider.js';
/**
 * Global {@link LeaderboardsProvider}.
 *
 * Allows registering multiple services to automatically detect
 * available ones and fall-back to others.
 *
 * Will post scores to all services, and retrieve scores from the first.
 */
class Leaderboards extends AbstractGlobalProvider {
    name = 'uber-leaderboards-provider';
    postScore(leaderboardId, score) {
        return Promise.all(this.providers.map((p) => p.postScore(leaderboardId, score))).then((wasBetter) => {
            /* The score was better only if it was better on all leaderboards */
            return wasBetter.reduce((a, b) => a && b, true);
        });
    }
    getScores(leaderboardId, maxCount) {
        if (!this.hasProviders())
            return Promise.reject(new Error('No providers available.'));
        return this.providers[this.providers.length - 1].getScores(leaderboardId, maxCount);
    }
}
export const leaderboards = new Leaderboards();
